<template><svg xmlns="http://www.w3.org/2000/svg" width="61" height="44" viewBox="0 0 35 45">
  <g style="stroke: currentColor; stroke-width: 2.38; fill: none; fill-rule: evenodd; stroke-linecap: round; stroke-linejoin: round" transform="translate(1 1)">
    <path d="m1.96 8.81 1.67 31.68h25.42l1.67-31.68" />
    <path d="m22.8 4.79v-4.6h-12.92v4.6" />
    <path d="m.19 5.37h32.3" />
    <path d="m9.84 11.56v23.48" />
    <path d="m16.39 11.56v23.48" />
    <path d="m22.94 11.56v23.48" />
  </g>
</svg>
</template>